import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=00e33076"
import script from "./Invoices.vue?vue&type=script&lang=js"
export * from "./Invoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports